module.exports = __webpack_public_path__ + "img/ic-visa.f90823fa.svg";